module.exports = __webpack_public_path__ + "img/well_friend_bg.14605b91.png";